import * as React from 'react';
import { parseArrayBuffer } from 'midi-json-parser';
import PianoRoll from './PianoRoll';
import { trackToScore } from './utils';
import ReactAudioPlayer from './ReactAudioPlayerFork';
let midiParser = require('midi-parser-js');

const Player = ({ title, midiFilePath, audioFilePath }) => {
	const [score, setScore] = React.useState({});
	const [audioMillis, setAudioMillis] = React.useState(null);
	const [elapsedMillis, setElapsedMillis] = React.useState(0);
	const [audioRef, setAudioRef] = React.useState(null);
	const [isPlaying, setIsPlaying] = React.useState(null);

	React.useEffect(() => {
		var oReq = new XMLHttpRequest();
		oReq.open('GET', midiFilePath, true);
		oReq.responseType = 'arraybuffer';

		oReq.onload = function (oEvent) {
			var arrayBuffer = oReq.response; // Note: not oReq.responseText

			parseArrayBuffer(arrayBuffer).then((json) => {
				let track = json.tracks.sort((a, b) => a.length - b.length)[0];

				let el = trackToScore(track, json.division);

				setScore(el);
			});
		};

		oReq.send(null);
	}, [midiFilePath]);

	const togglePlay = () => {
		if (!isPlaying) {
			play();
		} else {
			stop();
		}
	};

	const stopAll = () => {
		var sounds = document.getElementsByTagName('audio');
		for (var i = 0; i < sounds.length; i++) {
			sounds[i].pause();
		}
	};

	const play = () => {
		stopAll();
		if (audioRef.current) {
			audioRef.current.play();
		}
	};

	function stop() {
		if (audioRef && audioRef.current) {
			audioRef.current.pause();
			setElapsedMillis(0);
			audioRef.current.currentTime = 0;
		}
	}

	return (
		<div style={{ display: 'flex', flexDirection: 'column' }}>
			<div
				style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}
			>
				<p style={{ fontWeight: 500, marginBottom: 0, marginTop: 10 }}>{title}</p>
			</div>
			<hr></hr>

			<ReactAudioPlayer
				onEnded={(e) => stop()}
				onLoadedMetadata={(e) => setAudioMillis(e.target.duration * 1000)}
				src={audioFilePath}
				listenInterval={32}
				onPause={() => {
					audioRef.current.currentTime = 0;
					setElapsedMillis(0);
				}}
				onListen={(elapsedSeconds) => setElapsedMillis(elapsedSeconds * 1000.0)}
				onSeeked={(elapsedSeconds) => setElapsedMillis(elapsedSeconds * 1000.0)}
				setAudioRef={setAudioRef}
				onPlay={() => setIsPlaying(true)}
				onPause={() => setIsPlaying(false)}
			></ReactAudioPlayer>

			<div style={{ position: 'relative', width: 800, maxWidth: '90vw', height: 0, paddingTop: '20%' }}>
				<div style={{ top: 0, left: 0, width: '100%', height: '100%', position: 'absolute' }}>
					<PianoRoll
						displayDuration={audioMillis}
						score={{ ...score, isOdeToJoy: midiFilePath.includes('ode_to_joy') }}
					></PianoRoll>

					<div
						style={{
							transformOrigin: 'y-axis left',
							background: 'orange',
							width: '0.5%',
							height: '100%',
							left: (audioMillis ? (100 * elapsedMillis) / audioMillis : 0) - 0.5 + '%',
							position: 'absolute',
							top: 0,
							boxSizing: 'border-box',
						}}
					></div>
					<div
						onClick={togglePlay}
						style={{
							top: 0,
							left: 0,
							position: 'absolute',
							display: 'flex',
							flexDirection: 'row',
							alignItems: 'center',
							justifyContent: 'center',
							width: '100%',
							height: '100%',
							backdropFilter: isPlaying ? ' ' : 'opacity(10%)',
						}}
					>
						{isPlaying ? (
							<img
								style={{ width: 40, height: 40, color: 'orange' }}
								src={process.env.PUBLIC_URL + '/stop.svg'}
							></img>
						) : (
							<img
								style={{ width: 40, height: 40, color: 'orange' }}
								src={process.env.PUBLIC_URL + '/play.svg'}
							></img>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default Player;
